import {
  axios, axiosPersonal, fileAxios,
} from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    documentos: [],
  },

  getters: {
    getDocumentos: (state) => state.documentos,
  },

  mutations: {
    SET_DOCUMENTOS(state, documentos) {
      state.documentos = documentos;
    },
  },

  actions: {
    async fetchDocumentoByPersonal({ commit }, idPersonal) {
      await axios
        .get(`EonCloud/EstadoFuerza/personal/${idPersonal}/documento`)
        .then((response) => {
          commit('SET_DOCUMENTOS', response.data.data);
        });
    },

    async saveDocumentoPersonal(context, documentoPersonal) {
      await axios
        .post(`EonCloud/EstadoFuerza/personal/${documentoPersonal.fk_idPersonal}/documento`, documentoPersonal)
        .then((response) => {
          const formData = new FormData();
          formData.append('file', documentoPersonal.file);
          formData.append('iddocumentosPersonal', response.data.data[0].ID);
          context.dispatch('uploadDocumento', formData);
        });
    },

    async updateDocumentoPersonal(_, documentoPersonal) {
      await axios
        .put(`EonCloud/EstadoFuerza/personal/${documentoPersonal.fk_idPersonal}/documento/${documentoPersonal.id}`, documentoPersonal);
    },

    async updateEstatusDocumento(context, documentoPersonal) {
      await axios
        .put(`EonCloud/EstadoFuerza/personal/${documentoPersonal.idPersonal}/documento/${documentoPersonal.idDocumento}/estatus`, {
          fk_idEstatus: 2,
        })
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Documento eliminado correctamente.', {
            root: true,
          });
        });
    },

    async uploadDocumento(context, formData) {
      await fileAxios
        .post('/Documento/uploadFiles', formData)
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Documento guardado correctamente.', {
            root: true,
          });
        });
    },

    async fetchDocumentosPersonal(_, idPersonal) {
      return axiosPersonal
        .get(`EonCloud/EstadoFuerza/personal/${idPersonal}/documento`)
        .then((response) => response.data.data);
    },
  },
};
